import React from 'react';
import styled from 'styled-components';
import { Link } from 'react-router-dom';
import Typography from '@material-ui/core/Typography';

import colors from '../../styles/colors';
import InstagramButton from '../InstragramButton';

const FooterWrapper = styled.div`
    display: flex;
    ${props => props.theme.breakpoints.down('xs')} {
        flex-direction: column;
    };
    justify-content: space-around;
    background-color: ${props => props.theme.palette.primary.main};
    color: ${props => props.theme.palette.primary.contrastText};
    padding: 8px 0;
`;

const FooterSubPart = styled.div`
    ${props => props.theme.breakpoints.down('xs')} {
        margin-left: 16px;
    };
`;

const FooterSubPartTitle = styled.div`

`;

const FooterSubPartContent = styled.div`
    display: flex;
    flex-direction: column;
    border-left: 2px solid ${props => props.theme.palette.primary.contrastText};
    div {
        margin-left: 8px;
    }
`;

const LinkFooter = styled(Link)`
    text-decoration: none;
    color: ${colors.white};
    &:hover {
        text-decoration: underline
    }
`;

const Footer = () => {
    return (
        <FooterWrapper>
            <FooterSubPart>
                <FooterSubPartTitle>
                    <Typography variant="overline">小麦屋</Typography>
                </FooterSubPartTitle>
                <FooterSubPartContent>
                        <Typography component="div" variant="overline">住所 ｜〒425-0015 静岡県焼津市石脇上59-3（<LinkFooter to="/access">アクセス</LinkFooter>）</Typography>
                        <Typography component="div" variant="overline">TEL/FAX ｜054-628-5160</Typography>
                        <Typography component="div" variant="overline">営業時間 ｜AM 11:00 - PM 14:00</Typography>
                        <Typography component="div" variant="overline">定休日 ｜土曜日、日曜日、祝日</Typography>
                </FooterSubPartContent>
            </FooterSubPart>
            <FooterSubPart>
                <FooterSubPartTitle><Typography variant="overline">サイトマップ</Typography></FooterSubPartTitle>
                <FooterSubPartContent>
                    <Typography component="div" variant="overline"><LinkFooter to="/">ホーム</LinkFooter></Typography>
                    <Typography component="div" variant="overline"><LinkFooter to="/about">小麦屋について</LinkFooter></Typography>
                    <Typography component="div" variant="overline"><LinkFooter to="/gallery">ギャラリー</LinkFooter></Typography>
                    <Typography component="div" variant="overline"><LinkFooter to="/access">アクセス</LinkFooter></Typography>
                </FooterSubPartContent>
            </FooterSubPart>
            <FooterSubPart>
                <FooterSubPartTitle><Typography variant="overline">インスタグラム</Typography></FooterSubPartTitle>
                <InstagramButton />
            </FooterSubPart>
        </FooterWrapper>
    )
}

export default Footer;